import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import synchronize from './submodules/synchronize';
import qs from 'qs';
import $utils from '@/utils';


const state = {
    stock: null,
    stocks: [],
    stocks_loaded: false,
    stocks_loading: false,
    stocks_loading_errors: null,
};


const mutations = {
    updateStocks(state, stocks) {
        state.stocks = stocks;
        state.stocks_loaded = true;
        state.stocks_loading = false;
    },
    updateStocksLoading(state, loading) {
        state.stocks_loading = loading;
        if (loading) {
            state.stocks_loading_errors = null;
            state.stocks_loaded = false;
        }
    },
    updateStocksLoadingErrors(state, errors) {
        state.stocks_loading_errors = errors;
        state.stocks_loading = false;
        state.stocks_loaded = false;
    },
    updateStocksCount(state, stocks_count) {
        state.stocks_count = stocks_count;
    },

    updateStock(state, stock) {
        state.stock = stock;
    },
};

const actions = {
    init({ commit, dispatch, state }, params) {
        dispatch("synchronize/init");
        commit('updateStock', null);
        dispatch("fetchStocks");
    },

    changeStock({ commit, dispatch, state }, stock) {
        commit("updateStock", stock);
        commit("synchronize/updateExtraParams", { stock });
    },

    async fetchStocks({ commit, dispatch, state }, params) {
        commit('updateStocksLoading', true);
        try {
            const response = await axios.get('/api/stocks/', {
                params: { limit: 500, owned: true },
            });
            commit('updateStocks', response.data.results);
            commit('updateStocksCount', response.data.count);
            return response;
        } catch (xhr_error) {
            let error = utils.handleError(xhr_error);
            commit('updateStocksLoading', false);
            throw error;
        }
    },

    exportStockProductsAsCSV({ commit, dispatch, state }, params) {
        let filters = {};
        filters.stock = state.stock;
        filters.format = 'csv';
        filters.limit = 20000;
        filters.exclude_empty = true;
        
        $utils.downloadFile({
            url: "/api/stockproducts/",
            params: filters,
        }, $utils.getFilename('stockProducts'));
    },

    exportProductsAsCSV({ commit, dispatch, state }, params) {
        let filters = {};
        filters.stock = state.stock;
        filters.format = 'csv';
        filters.limit = 20000;
        
        $utils.downloadFile({
            url: "/api/products/",
            params: filters,
        }, $utils.getFilename('products'));
    },
};

export default {
    namespaced: true,
    state,

    actions,
    mutations,
    modules: {
        synchronize: synchronize(),
    }
};
